export default class Settings {
  public apiSubscription?: string;
  public apiClientId?: string;
  public apiClientSecret?: string;
  public userId?: string;
  public clientName?: string;

  constructor(obj: any) {
    this.apiSubscription = obj?.apiSubscription;
    this.apiClientId = obj?.apiClientId;
    this.apiClientSecret = obj?.apiClientSecret;
    this.userId = obj?.userId;
    this.clientName = obj?.clientName;
  }
}
